/**
 * 必须与 tools/search-index/src/buildIndex.ts 中 miniSearchOptions 完全一致，
 * 否则浏览器端 loadJS 与 Node 端序列化不匹配。
 */
export const miniSearchOptions = {
  idField: "id",
  fields: ["text"],
  storeFields: ["id", "anchorId", "file", "juan", "text"],
  tokenize: (text: string, _fieldName?: string): string[] => Array.from(text),
  processTerm: (term: string) => term,
};
